import React, { Fragment, useState } from "react";
import {
  Popover,
  PopoverButton,
  PopoverPanel,
  Transition,
} from "@headlessui/react";
import { CiUser } from "react-icons/ci";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { HiMenuAlt2 } from "react-icons/hi";
import adminService from "../api/services/adminService";
import toast from "react-hot-toast";

const Topbar = ({ showNav, setShowNav }) => {
  const [openMenu, setOpenMenu] = useState(false);
  const data = localStorage.getItem("adminUserDetails");
  const userData = data ? JSON.parse(data) : null;

  const navigate = useNavigate();

  const logoutHandler = async () => {
    try {
      // Call logout API
      await adminService.logout();

      // Clear cookies
      Cookies.remove("token");
      Cookies.remove("naseebiadmin");

      // Clear localStorage
      localStorage.clear();

      toast.success("Logged out successfully");
      navigate("/login", { replace: true });
    } catch (error) {
      console.error("Logout error:", error);
      // Even if API call fails, clear local data and redirect
      Cookies.remove("token");
      Cookies.remove("naseebiadmin");
      localStorage.clear();
      navigate("/login", { replace: true });
    }
  };
  return (
    <div
      className={`w-screen h-16 md:h-20 flex justify-between items-center transition-all duration-[400ms] px-2 md:px-4`}>
      <button
        type="button"
        aria-label="Toggle navigation"
        className="md:hidden flex items-center justify-center p-2 rounded hover:bg-gray-100 text-gray-700"
        onClick={() => setShowNav(!showNav)}>
        <HiMenuAlt2 className="h-7 w-7" />
      </button>
      <div className="text-black flex flex-row font-bold items-center justify-center py-2 md:py-3 px-2 md:px-3 lg:ml-6 ml-1 min-w-0">
        <div className="mr-2">
          <img
            src={require("../assests/logo.png")}
            alt="Naseebi Admin logo"
            className="h-6 md:h-8 w-auto"
          />
        </div>
        <div className="min-w-0">
          <p className="text-sm md:text-xl text-[#FF2D38] font-bold truncate">
            Naseebi Admin Panel
          </p>
        </div>
      </div>
      <div
        className={`transition-all flex gap-2 items-center duration-[400ms] ${
          showNav ? "" : "pr-6  "
        }`}>
        <div className="font-bold hidden sm:block">
          {userData?.firstName === "Naseebi"
            ? userData?.lastName
            : userData?.firstName || "Admin"}
        </div>
        <div>
          <Popover className="relative">
            <PopoverButton
              onClick={() => setOpenMenu(!openMenu)}
              className="flex gap-2 outline-none mr-1 md:mr-8 cursor-pointer text-gray-700">
              {userData.imageUrl ? (
                <div className="relative w-10 h-10 md:h-12 md:w-12 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={userData.imageUrl}
                    alt="Your avatar"
                    className="w-full h-full object-cover"
                  />
                </div>
              ) : (
                <CiUser className="h-8 w-8 md:h-10 md:w-10 border-2 rounded-full border-gray-600 p-2 mt-[6px] hover:bg-black hover:text-white hover:font-extrabold hover:border-white" />
              )}
            </PopoverButton>
            <Transition
              as={Fragment}
              enter="transition ease-out duration-100"
              enterFrom="transform scale-95"
              enterTo="transform scale-100"
              leave="transition ease-in duration-75"
              leaveFrom="transform scale-100"
              leaveTo="transform scale-95">
              <PopoverPanel className="mr-4 md:mr-10 absolute -right-2 sm:-right-8 z-50 mt-3 bg-white border-2 border-[#FEBE77] shadow-gray-400 shadow-lg rounded-md max-w-xs w-[180px] sm:w-[200px]">
                <div>
                  <>
                    <center className="">
                      {/* <div className="text-[14px] font-[400]">Bilal</div>
                                        <div className="text-[12px] font-[600]">mbm@gmail.com</div> */}
                      <button
                        onClick={logoutHandler}
                        className="mt-4 text-center justify-center w-[60%] sm:w-[50%] rounded bg-red-600 text-white font-[600] py-1 mb-4 shadow-md text-[0.8rem] hover:bg-red-700 hover:text-white">
                        Logout
                      </button>
                    </center>
                  </>
                </div>
              </PopoverPanel>
            </Transition>
          </Popover>
        </div>
      </div>
    </div>
  );
};

export default Topbar;
